/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';

import { SidenavBarSVG } from '../img/GlobalSVG';

const sidebarMenu = [
  {
    id: 0,
    text: 'Admin Dashboard',
    route: '/admin/admin-dashboard',
    menuImg1: <SidenavBarSVG.DashboardSVG />,
    menuImg2: <SidenavBarSVG.DashboardSVG />,
    alt: 'Dashboard',
  },
  /*,
  {
    id: 1,
    text:'ID Card',
    route:'/myidcards',
    menuImg1: <SidenavBarSVG.IDCardSVG/>,
    menuImg2:<SidenavBarSVG.IDCardSVG/> ,
    alt:'Id Card'
  },
  {
    id: 2,
    text:'Coverage',
    route:'/coverage',
    menuImg1: <SidenavBarSVG.CoverageSVG/>,
    menuImg2: <SidenavBarSVG.CoverageSVG/>,
    alt:'Coverage'
  },
  {
    id: 3,
    text:'Claims',
    route:'/claims',
    menuImg1: <SidenavBarSVG.ClaimsSVG/>,
    menuImg2:<SidenavBarSVG.ClaimsSVG/>,
    alt:'Claims'
  },
  {
    id: 4,
    text:'Account',
    route:'/accounts',
    menuImg1: <SidenavBarSVG.AccountSVG/>,
    menuImg2: <SidenavBarSVG.AccountSVG/>,
    alt:'Account'
  }
  */
];

export default sidebarMenu;
